import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      justifyContent: 'center',
      overflow: 'unset',
    },
  },
  content: {
    padding: [theme.spacing(4), theme.spacing(3), 0],
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 700,
      width: '100%',
      height: '100%',
      maxWidth: 1420,
      flexDirection: 'row',
    },
  },
  label: {
    marginBottom: theme.spacing(4),
  },
  favoriteLoanOfficers: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    [theme.breakpoints.up('mobile')]: {
      width: 400,
      minWidth: 400,
    },
  },
  loanOfficers: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    [theme.breakpoints.up('mobile')]: {
      marginLeft: theme.spacing(4),
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/useStyles.js